import React, { useState } from 'react';
import { Button, CircularProgress, Snackbar, Alert } from '@mui/material';
import { Download } from '@mui/icons-material';
import { dashboardAPI } from '../../../services/dashboard-api';
import { track } from '../../../utils/analytics';

// Export CSV = the current view with the current filters and sort (spec §1.3, §2.5). Server-built file.
const ExportCsvButton = ({ params, view, disabled, minHeight, tab = 'products' }) => {
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState('');

  const handleClick = async () => {
    setBusy(true);
    try {
      const download = tab === 'brands' ? dashboardAPI.downloadBuyerInsightsBrandsCsv : dashboardAPI.downloadBuyerInsightsCsv;
      const { rowCount } = await download.call(dashboardAPI, params);
      track('Buyer Insights CSV Exported', { tab, view, rows: rowCount });
    } catch (e) {
      setError(e.hint ? `${e.message}. ${e.hint}` : e.message || 'Export failed');
    } finally {
      setBusy(false);
    }
  };

  return (
    <>
      <Button
        size="small"
        variant="outlined"
        onClick={handleClick}
        disabled={disabled || busy}
        startIcon={busy ? <CircularProgress size={16} /> : <Download />}
        sx={{ minHeight }}
      >
        Export CSV
      </Button>
      <Snackbar open={Boolean(error)} autoHideDuration={6000} onClose={() => setError('')}>
        <Alert severity="error" onClose={() => setError('')} variant="filled">
          {error}
        </Alert>
      </Snackbar>
    </>
  );
};

export default ExportCsvButton;
